import { Fragment } from 'react'
import AdminAccount from './components/AdminAccount'
import CreateResult from './components/CreateResult'
import FormLayout from './components/FormLayout'
import GreetAndWelcome from './components/GreetAndWelcome'
import RestaurantInfo from './components/RestaurantInfo'
import RestaurantLocation from './components/RestaurantLocation'
import RestaurantSetup from './components/RestaurantSetup'
import {
    CreateCompanyContextProvider,
    CreateCompanyStep,
    useCreateCompanyContext,
} from './CreateCompanyContext'

function CreateCompanyContainer() {
    const { step } = useCreateCompanyContext()

    const renderStep = () => {
        switch (step) {
            case CreateCompanyStep.AdminAccount:
                return <AdminAccount />
            case CreateCompanyStep.RestaurantInfo:
                return <RestaurantInfo />
            case CreateCompanyStep.RestaurantLocation:
                return <RestaurantLocation />
            case CreateCompanyStep.RestaurantSetup:
                return <RestaurantSetup />
            case CreateCompanyStep.Completed:
                return <CreateResult />
            default:
                return <GreetAndWelcome />
        }
    }

    const Layout = step !== undefined ? FormLayout : Fragment

    return <Layout>{renderStep()}</Layout>
}
function CreateCompany() {
    return (
        <CreateCompanyContextProvider>
            <CreateCompanyContainer />
        </CreateCompanyContextProvider>
    )
}

export default CreateCompany
